import { gql } from '@apollo/client';

const GET_ATTENDANCE_SUMMARY = gql`
  mutation GetAttendanceSummary($month: String!) {
    getAttendanceSummary(month: $month) {
      overtime
      thisMonth
      thisWeek
      thisYear
      today
    }
}
`;

const GET_ATTENDANCE_STATS = gql`
  mutation GetUserAttendanceStats($month: String!) {
    getUserAttendanceStats(month: $month) {
      averageDailyHours
      totalAbsentDays
      totalHours
      totalPresentDays
      totalWorkingDays
    }
  }
`;


export { GET_ATTENDANCE_SUMMARY, GET_ATTENDANCE_STATS }